<form class="needs-validation" novalidate>
	<ngb-alert #selfClosingAlert *ngIf="message" [type]="messageType" (close)="message=''">
		<span [innerHTML]="message"></span>
	</ngb-alert>

	<ng-content></ng-content>
</form>
